import React, {useState} from "react";
import {Alert} from "reactstrap";
import ResponsiveImageSet from "../../../components/UI/ResponsiveImageSet/ResponsiveImageSet";
import NumbersAndBrandXs from "../../../assets/images/zahlen-und-marken-xs-rgb.webp"
import NumbersAndBrandLg from "../../../assets/images/zahlen-und-marken-lg-rgb.webp"
import Cookies from "js-cookie";

const NumbersAndBrand = (props) =>{
    const cookieName = "bigfoot_numbers-and-brand";
    const cookiesForNumbersAndBrand = Cookies.get(cookieName);

    const [isVisible, setIsVisible] = useState(!cookiesForNumbersAndBrand);

    const toggleVisibility = () => {
        setIsVisible(!isVisible);
        Cookies.set(cookieName, true ,{expires: 180});
    }

    if(process.env.REACT_APP_NUMBERS_AND_BRAND_COMPONENT === "true" && isVisible){
        return (
            <Alert color="dark" isOpen={isVisible} toggle={toggleVisibility} className={"p-0 overflow-hidden"}>
                <ResponsiveImageSet imageXs={NumbersAndBrandXs} imageLg={NumbersAndBrandLg} altText="Zahlen und Marke"/>
            </Alert>
        );
    } else {
        return (<></>)
    }
}

export default NumbersAndBrand;